import { render } from "./GreatLeaderCharacteristics.vue?vue&type=template&id=308bf97c"
import script from "./GreatLeaderCharacteristics.vue?vue&type=script&lang=js"
export * from "./GreatLeaderCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script